import 'magnific-popup';

$('.js-product-form').on('submit', function (event) {
  event.preventDefault();

  var defaultOption = 'Please select your size';
  var defaultOptionOne = '-';
  var defaultOptionTwo = '--';
  var productSelectedSize = $('#product-select').find(':selected').text();

  if (
    productSelectedSize == defaultOption ||
    productSelectedSize == defaultOptionOne ||
    productSelectedSize == defaultOptionTwo
  ) {
    selectSizePopup();
    return;
  }

  const totalVariants = $('.js-main-select')
    .find('option:selected')
    .data('total-items');
  const $this = $(this);
  let flag = false;
  let $btn;
  if ($('.js-product-btn').length) {
    $btn = $('.js-product-btn');
    $btn.addClass('disable');
    flag = true;
  }

  $.ajax({
    url: '/cart/add',
    data: $this.serialize(),
    type: 'POST',
    beforeSend: function () {
      if (flag) {
        $('.js-add').addClass('toggle');
        $('.js-adding').addClass('toggle');
      }
    },
  })
    .done(function (data) {
      changeCounter(data);
      if (flag) {
        $('.js-adding').removeClass('toggle');
        $('.js-added').addClass('toggle');

        setTimeout(function () {
          $('.js-added').removeClass('toggle');
          checkoutPopup();
          setTimeout(function () {
            $('.js-add').removeClass('toggle');
            $btn.removeClass('disable');
          }, 400);
        }, 2000);
      }
    })
    .fail(function (data) {
      alert(`There are currently ${totalVariants} units from this variant.`);
      if (flag) {
        $('.js-adding').removeClass('toggle');

        setTimeout(function () {
          $('.js-add').removeClass('toggle');
        }, 400);
        $btn.removeClass('disable');
      }
    });
});

function changeCounter(data) {
  const $cartTextLink = $('.js-count');

  let cartTextNew = $(data).find('.item-counter').text();

  $cartTextLink.text(cartTextNew);

  let count = parseInt(cartTextNew);
}

function checkoutPopup() {
  $.magnificPopup.open({
    items: {
      src: $('#popup-checkout'),
    },
    type: 'inline',
    fixedBgPos: false,
    fixedContentPos: false,
    mainClass: 'mfp-checkout-popup',
  });
}

function selectSizePopup() {
  $.magnificPopup.open({
    items: {
      src: $('#select-size-popup'),
    },
    type: 'inline',
    fixedBgPos: false,
    fixedContentPos: false,
    mainClass: 'mfp-checkout-popup',
  });
}
